import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { FDTextButton } from '@facet-wealth/design';
import { dataAttrs, testAttr } from 'Helpers/Testing';
import AuthenticationFactorListItemEnabled
  from 'Components/ComponentLibrary/Organisms/AuthenticationFactorList/AuthenticationFactorListItem/AuthenticationFactorListItemActionPicker/AuthenticationFactorListItemEnabled';
import { useAuthenticationFactorListContext } from '../../AuthenticationFactorListContext';

const AuthenticationFactorListItemActionRequired = ({
  authenticationFactorResource: factorResource,
}) => {
  if (!factorResource.isTruthy('isRequired')) {
    throw new Error('Can only render a required auth factor');
  }
  const { setModalLink } = useAuthenticationFactorListContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  return factorResource.withRelationship(fr.relationships.authenticationFactorModify.name, (rel) => {
    const handleUpdateAuthenticationFactor = (authenticationType) => {
      logStandardizedEvent(categories.userSettingsSecurity, eventTypes.clickButton, `Authentication Type ${authenticationType} Modify: Open change password modal`);
      setModalLink(rel.link('related'));
    };

    return (
      <FDTextButton
        {...dataAttrs('authentication factor', factorResource, {
          [testAttr.dataAction]: 'modify',
        })}
        size={'sm'}
        onClick={() => handleUpdateAuthenticationFactor(factorResource.attr('authenticationType'))}
        label={'Update'}
        data-test={`security-settings-required-auth-factor-modify-${factorResource.attr('authenticationType')}`}
      />
    );
  }, () => {
    // Just show the enabled button but don't allow modification
    return (<AuthenticationFactorListItemEnabled authenticationFactorResource={factorResource} />);
  });
};

AuthenticationFactorListItemActionRequired.propTypes = {
  authenticationFactorResource: PropTypes.object.isRequired,
};

export default AuthenticationFactorListItemActionRequired;
